import React from 'react';
import styled from 'styled-components';
import { INK } from '../onboarding/review/reviewStyles';
export const WorkspaceGuide = styled.section`
  margin: 14px 0; padding: 18px 20px; border: 1px solid #38536e; border-radius: 12px;
  background: linear-gradient(110deg, #18283b, #101725); color: ${INK.body};
  h2, h3 { margin: 0 0 6px; font-size: 17px; color: ${INK.strong}; }
  p { margin: 5px 0; max-width: 90ch; color: ${INK.muted}; font-size: 13px; line-height: 1.7; }
  .actions { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
`;
export const WorkspaceTools = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin: 14px 0;
  input, select { color: ${INK.body}; background: ${INK.well}; border: 1px solid ${INK.lineStrong}; border-radius: 8px; padding: 10px 12px; font: inherit; }
  input[type=search] { flex: 1; min-width: 220px; }
  label, span { color: ${INK.muted}; font-size: 13px; }
`;
export const WorkspaceDisclosure = styled.details`
  border: 1px solid ${INK.line}; border-radius: 10px; padding: 14px 18px; margin: 14px 0; background: ${INK.panel}; color: ${INK.body};
  > summary { cursor: pointer; font-size: 14px; font-weight: 650; padding: 4px 0; }
  > summary small { margin-left: 10px; color: ${INK.muted}; font-weight: 400; }
`;
const Nav = styled.nav`
  display: flex; flex-wrap: wrap; gap: 6px; margin: 14px 0; border-bottom: 1px solid ${INK.line};
  button { color: ${INK.muted}; border: 0; border-bottom: 2px solid transparent; padding: 13px 16px; background: transparent; font: inherit; font-size: 14px; cursor: pointer; }
  button[aria-pressed=true] { color: ${INK.strong}; border-bottom-color: #9cd7f7; background: #172638; }
  button:focus-visible { outline: 2px solid #9cd7f7; outline-offset: -2px; }
`;
export function WorkspaceViews({label, value, items, onChange}: {label: string; value: string; items: {key: string; label: string}[]; onChange: (key: string) => void}) {
  return <Nav aria-label={label}>{items.map(item => <button key={item.key} type="button" aria-pressed={value === item.key} onClick={() => onChange(item.key)}>{item.label}</button>)}</Nav>;
}
